import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { SyncDataService } from './../../services/sync-data.service';
import { InfoDialogComponent } from '../../../shared/components/info-dialog/info-dialog.component';
import { ACustomStepWizard } from '../../../shared/components/wizard/step-wizard/abstract-custom-step-wizard';
import { Observable, of, from } from 'rxjs';
import { IFacadeColumnDescriptor } from 'app/core/typings/IFacadeColumnDescriptor';
import { IFacadeTableDescriptor } from 'app/core/typings/IFacadeTableDescriptor';
import { IFacadeExportObject } from 'app/core/typings/IFacadeExportObject';

@Component({
  selector: 'app-export-step30',
  templateUrl: './export-step30.component.html',
  styleUrls: ['./export-step30.component.scss', '../../sync-data.component.scss']
})
export class ExportStep30Component extends ACustomStepWizard<{ syncData: IFacadeExportObject }> implements OnChanges {
  @Input() data;
  @Input() exportOnlyUsers: boolean = false;
  @Output() exportLoading = new EventEmitter<boolean>();
  @ViewChild('infoDialog', { static: false }) infoDialog: InfoDialogComponent;

  public selectedTables: IFacadeTableDescriptor[];
  public filteredEntities: IFacadeColumnDescriptor[];
  public isLoading = false;
  public entitiesQuantity: number;
  public messageEntitiesRequired = '';
  public messageToUser: string;

  private loadingMessage = '';
  private idBrowser: Guid;
  private objectToExport: IFacadeExportObject = {
    EnabledMail: false,
    FilePath: '',
    FileToImport: null,
    Reports: null,
    OverrideTargetResources: null,
    EntityTables: null,
    UserTables: null,
    StringConnection: '',
    ProviderType: '',
    AreNewUsers: true,
    ModifiedDescriptor: '',
    OriginalDescriptor: '',
    UsersAvailable: true,
    UsersSelected: true,
  };

  constructor(private _syncDataService: SyncDataService) {
    super('')
  }

  ngOnChanges(): void {
    if (this.data) {
      this.load();
    }

    if (this.exportOnlyUsers) {
      this.isValid();
    }
  }

  public load() {
    this.entitiesQuantity = 0;
    this.getAvailableTables();
  }

  public isValid(): Observable<boolean> {
    this.isLoading = true;
    if (!this.data.syncData.OverrideTargetResources)
      this.data.syncData.OverrideTargetResources = true;

    if (this.validateFinish()) {
      this.exportLoading.emit(true);
      return from(this._syncDataService.export(this.objectToExport).then(() => {
        this.isLoading = false;
        return true;
      }));
    }
    else {
      this.isLoading = false;
      this.exportLoading.emit(false);
      return of(false);
    }

  }

  public onTableSelected(itemEntity: IFacadeTableDescriptor): void {
    this.filteredEntities = itemEntity.EntityKeysSource;
    this.selectedTables.forEach((item) => item.SelectedUI = false);
    itemEntity.SelectedUI = true;
  }

  public onSelectEntity(entityKey: IFacadeColumnDescriptor): void {
    entityKey.Selected = !entityKey.Selected;
  }

  private validateFinish(): boolean {
    let result = true;
    this.messageToUser = '';
    this.messageEntitiesRequired = '';

    this.objectToExport = { ...this.objectToExport, ...this.data.syncData };

    if (this.selectedTables) {
      this.objectToExport.EntityTables = this.selectedTables;
    }

    if (this.objectToExport.UserTables) {
      this.objectToExport.UserTables = this.objectToExport.UserTables.filter(x => x.Selected === true);
      this.objectToExport.UserTables.forEach(x => x.TableName = null);
    }

    const entitiesCount = (this.objectToExport.EntityTables ? this.objectToExport.EntityTables.length : 0) +
      (this.objectToExport.UserTables ? this.objectToExport.UserTables.length : 0);

    if (entitiesCount === 0) {
      result = false;
      this.messageToUser = 'SYNC_DATA.MUST_SELECT_AN_ENTITY';
    }
    else {
      for (const item of this.objectToExport.EntityTables) {
        if (item.EntityKeysSource) {
          if (item.EntityKeysSource.findIndex((entity) => entity.Selected === true) === -1) {
            if (this.messageEntitiesRequired.length === 0) {
              this.messageEntitiesRequired = ': '
            }
            this.messageEntitiesRequired += item.DisplayName + ', ';
          }
        }
      }

      if (this.messageEntitiesRequired.length > 0) {
        result = false;
        this.messageToUser = 'SYNC_DATA.ENTITY_KEY_REQUIRED';
        this.messageEntitiesRequired = this.messageEntitiesRequired.substring(0, this.messageEntitiesRequired.length - 2);
      }
    }

    return result;
  }

  private getAvailableTables(): void {
    if (this.data.syncData.EntityTables) {
      this.selectedTables = this.data.syncData.EntityTables.filter(x => x.Selected === true);
      this.selectedTables = this._syncDataService.orderEntityList(this.selectedTables);
      if (this.selectedTables && this.selectedTables.length > 0) {
        this.onTableSelected(this.selectedTables[0]);
      }
      else {
        this.filteredEntities = null;
      }
    }
  }

}
